// 比赛信息
export const EventInfo = {
    // 活动基本信息
    eventCode: 240654,
    channel: "teacherExam", //网址：c.icode.org.cn/channel
    bannerLinks: [{
        //     name: "排行榜",
        //     link: "https://ix.icode.org.cn/rankBoard?eventCode=234321"
        // }, {
        name: "返回培训平台",
        link: "https://c.icode.org.cn/teacher"
    }],
    eventGameList: [{
        name: "图形化编程", // 组别名称
        id: 24065401, // 比赛ID
        mode: 0, // 比赛模式：0-积木，1-Python
        minGrade: 0, // 组别最低年级（包含，1-12）
        maxGrade: 13 // 组别最高年级（包含，1-12）
    }, {
        name: "Python初级考核",
        id: 24065411,
        mode: 1,
        minGrade: 0,
        maxGrade: 13
    }],

    // 比赛首页
    bgIndex: 7, // 默认背景图编号：0-18
    bgFileUrl: "", // 自定义背景图链接地址，若不使用自定义背景则为""
    mainTitle: "ICode国际青少年编程竞赛<br>教师培训考核平台", // 主标题
    subTitle: "", // 副标题
    orgList: [
        "主办单位：ICODE中国区组委会",
        "技术支持：立乐教育科技（上海）有限公司"
    ],
    showSignUpBtn: false, // 是否显示注册按钮：true-显示，用户可以自行注册

    // 登录界面
    autoReg: false, // 自动报名开关：true-登录后，若未报名，可选择组别报名；false-必须由后台导入报名

    // 比赛公告页
    showSchoolRank: false, // 学校排行榜开关
    rankTitle: "ICode国际青少年编程竞赛教师培训考核", // 排行榜标题，支持<br>换行
    needPsw: false, // true-显示密码输入框，false-不显示密码输入框
    timeLimit: false, // true-显示60分钟限时赛的提示
    needVip: false, //true-只有VIP用户才能参加，false-所有用户都可以参加
    orgIds: [], // 可以参加活动的机构id，为空时所有机构都可参加
    testBtn: 0, // 设备测试按钮开关：0-不打开，1-打开带摄像头的测试，2-打开不带摄像头的测试
    notice: "欢迎参加ICode国际青少年编程竞赛教师培训考核，考核开始后，请刷新页面，点击【开始比赛】按钮进入考核！考核时长为60分钟。", // 公告栏内容
}


// WEBPACK FOOTER //
// ./src/components/contest/teacherExam2/eventConfig.js